import {
   CORE_LOAD_ALL_USER_REQUEST,
   CORE_LOAD_ALL_USER_SUCCESS,
   CORE_LOAD_ALL_USER_FAILURE,

   CORE_LOAD_USER_REQUEST,
   CORE_LOAD_USER_SUCCESS,
   CORE_LOAD_USER_FAILURE,

   REQUEST_STATE
} from '../types'

const initialState = []
   , initialStateObj = {}
   , requestState = REQUEST_STATE
export default {
   allUser: (state = requestState, action) => {
      switch (action.type) {
         case CORE_LOAD_ALL_USER_REQUEST:
            return requestState
         case CORE_LOAD_ALL_USER_SUCCESS:
            if (action.payload && Array.isArray(action.payload)) {
               return action.payload
            } else return []
         case CORE_LOAD_ALL_USER_FAILURE:
            return initialState
         default:
            return state
      }
   },
   userInfo: (state = requestState, action) => {
      switch (action.type) {
         case CORE_LOAD_USER_REQUEST:
            return requestState
         case CORE_LOAD_USER_SUCCESS:
            if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
               return action.payload
            } else return {}
         case CORE_LOAD_USER_FAILURE:
            return initialStateObj
         default:
            return state
      }
   },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerUser.js